export enum UserFeature {
  STANDARD_PLUS_JOB_OFFER_PACKAGE = "standardPlusJobOffersPackage",
  PREMIUM_JOB_OFFER_PACKAGE = "premiumJobOffersPackage",
  PRO_JOB_OFFER_PACKAGE = "proJobOffersPackage",
  EXTENDED_PROFILE = "extendedProfile",
  JOB_AGENCY_JOB_OFFERS = "jobAgencyJobOffers",
  OPEN_CANDIDATE_PROFILE_FEATURE = "openCandidateProfileFeature",
  CANDIDATE_PROFILE_FEATURE = "candidateProfileFeature",
  QAA_SHOW = "qaaShow",
}
